import React from 'react';
interface BadgeProps {
  children: React.ReactNode;
  variant?: 'default' | 'outline' | 'accent';
  className?: string;
}
export function Badge({
  children,
  variant = 'default',
  className = ''
}: BadgeProps) {
  const baseStyles = 'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium';
  const variants = {
    default: 'bg-primary/10 text-primary dark:bg-primary/20 dark:text-teal-300',
    outline: 'border border-border text-text-muted',
    accent: 'bg-accent/10 text-accent dark:bg-accent/20 dark:text-orange-300'
  };
  return <span className={`${baseStyles} ${variants[variant]} ${className}`} data-id="element-89">
      {children}
    </span>;
}